var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('c-flex', {
    attrs: {
      "flex": "1",
      "flex-dir": "column",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('c-image', {
    attrs: {
      "src": require('../img-meal-plan-empty.svg'),
      "alt": "meal plan empty illustration",
      "w": "200px"
    }
  }), _c('h1', {
    directives: [{
      name: "chakra",
      rawName: "v-chakra"
    }],
    attrs: {
      "mt": "10px",
      "color": "#111",
      "font-weight": "bold",
      "font-size": "16px",
      "font-family": "body"
    }
  }, [_vm._v(" Rekomendasi menumu masih kosong. ")]), _c('c-text', {
    attrs: {
      "mt": "10px",
      "max-w": "328px",
      "text-align": "center",
      "font-size": "14px",
      "color": "#828282"
    }
  }, [_vm._v(" Ahli gizi kami masih merencanakan rekomendasi menu sesuai preferensimu. Mohon ditunggu, ya! ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }